





















































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Snotify } from '@/snotify/Snotify';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { LoadingService } from '@/services/loadingService';

interface FormData {
  field1: string;
}

@Component({
  components: { FormFieldsContainer },
})
export default class FormularioComponente extends Vue {
  @Prop({ default: [] }) gpsList: any;
  @Prop({ default: false }) edit: any;
  @Prop({ default: [] }) editItem: any;
  loadingService = new LoadingService();
  editedItem: any = {};
  editedGps: any = [];
  gpsModelSelected: any = {};
  axiosPostgres: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  dataEntradasSelected: any = [];
  showEntradas: boolean = false;
  dataForm: any = [];
  onlyView: boolean = false;

  formfields: any = {
    entrada_digital: [],
  };
  dataResult: any = [];

  sensorList: any = [
    { name: 'Sin Sensor' },
    { name: 'Puerta 1' },
    { name: 'Puerta 2' },
    { name: 'Descarga' },
    { name: 'Pulsador' },
  ].sort((a, b) => a.name.localeCompare(b.name));

  iconList: any = [
    {
      icon_name: 'meeting_room',
      css_stye: 'cursor:pointer;color:red;font-size: 18px;',
    },
    {
      icon_name: 'door_front',
      css_stye: 'cursor:pointer;color:green;font-size: 18px;',
    },
    {
      icon_name: 'file_download',
      css_stye: 'cursor:pointer;color:green;font-size: 18px;',
    },
    {
      icon_name: 'file_download_off',
      css_stye: 'cursor:pointer;color:green;font-size: 18px;',
    },
    {
      icon_name: 'touch_app',
      css_stye: 'cursor:pointer;color:green;font-size: 18px;',
    },
    {
      icon_name: 'do_not_touch',
      css_stye: 'cursor:pointer;color:green;font-size: 18px;',
    },
    {
      icon_name: 'touch_app',
      css_stye: 'cursor:pointer;color:red;font-size: 18px;',
    },
  ];

  readonly msService: string = 'Metabase/PostgenericA/entradas_digitales';
  readonly $snotify: Snotify;

  /*constructor() {
    super();
    //actionsEvent.onEditar(this.handleEdit);
    //actionsEvent.onEliminar(this.handleDelete);
  }*/

  mounted() {
    this.editedItem = this.editItem;
    this.showEntradas = false;
    this.gpsModelSelected = {};
  }

  @Watch('gpsList', { immediate: true })
  async getasigados() {
    this.editedGps = this.gpsList.length > 0 ? this.gpsList : this.editedGps;
  }

  @Watch('editItem', { immediate: true })
  async getConfig() {
    this.editedItem = this.editItem;
    let axiosResponse = await this.axiosPostgres.http.post(
      `${this.msService}/get_entradas_digitales_by_vehiculo`,
      { vehiculoId: this.editedItem.id }
    );
    let response = axiosResponse.data;
    if (response.CODIGO_RESPUESTA == '1') {
      this.dataResult = response.config;
    }
    this.onlyView = !this.edit;
  }

  async getEntradas() {
    let _self = this;
    this.loadingService.showLoading();
    let marcaId = '';
    let modeloId = '';
    if (this.gpsModelSelected == undefined) {
      this.showEntradas = false;
      this.loadingService.hideLoading();
      return false;
    }
    marcaId = this.gpsModelSelected.gpsMarca.id;
    modeloId = this.gpsModelSelected.id;

    let flagAdd = false;
    this.formfields.entrada_digital = [];
    this.showEntradas = false;
    this.dataForm = [];
    let axiosResponse = await this.axiosPostgres.http.post(
      `${this.msService}/get_entradas_digitales_by_gps`,
      { marcaId: marcaId, modeloId: modeloId, vehiculoId: this.editedItem.id }
    );
    let response = axiosResponse.data;
    if (response.CODIGO_RESPUESTA == '1') {
      this.dataEntradasSelected = response.entradas_digitales;
      if (
        !this.dataResult.some(
          (item: any) => item.gpsModel === this.gpsModelSelected.nombre
        )
      ) {
        _self.dataResult.push({
          gpsModel: _self.gpsModelSelected.nombre,
          config: [],
        });
        flagAdd = true;
      }
      this.dataEntradasSelected.forEach((item: any) => {
        _self.formfields.entrada_digital.push({
          id: item.entries_data_json.entrada,
          value: item.entries_data_json.entrada,
          description: item.descripcion,
          cods_internos: item.cod_interno_json,
          eventos: item.entries_data_json.eventos,
        });
        if (flagAdd) {
          _self.dataResult.map((itemResult: any) => {
            if (itemResult.gpsModel == _self.gpsModelSelected.nombre) {
              itemResult.config.push({
                entrada: item.entries_data_json.entrada,
                parametro: item.entries_data_json.parametroId,
                eventos: [
                  { evento_fijo: item.entries_data_json.eventos[0] },
                  { evento_fijo: item.entries_data_json.eventos[1] },
                ],
              });
              _self.dataForm.push({
                sensor_type: { name: 'Sin Sensor' },
              });
            }
          });
        }
      });
      this.dataResult.map((item: any) => {
        if (item.gpsModel == _self.gpsModelSelected.nombre) {
          item.config.forEach((itemResult: any) => {
            _self.dataForm.push({
              sensor_type: itemResult.sensor_type,
              desc_evento_1: itemResult.eventos[0].desc_estado_sensor,
              icon_evento_1: itemResult.eventos[0].sensor_icon,
              desc_evento_2: itemResult.eventos[1].desc_estado_sensor,
              icon_evento_2: itemResult.eventos[1].sensor_icon,
            });
          });
        }
      });
      this.showEntradas = true;
    } else {
      this.$snotify.error(response.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
    this.loadingService.hideLoading();
  }

  updateFormField(index: number, event: any, type: string) {
    let estadoId: any;
    let typeInput: any;
    const selector = type.split('-');
    if (selector.length == 2) {
      typeInput = selector[0];
      estadoId = selector[1];
    } else {
      typeInput = type;
      estadoId = '';
    }
    this.dataResult.map((item: any) => {
      if (item.gpsModel == this.gpsModelSelected.nombre) {
        if (typeInput == 'desc_estado_sensor' || typeInput == 'sensor_icon') {
          item.config[index]['eventos'][parseInt(estadoId)][typeInput] = event;
        } else {
          item.config[index]['sensor_type'] = event;
        }
      }
    });
  }

  getFormData(): FormData {
    return this.dataResult;
  }

  cleanFormData() {
    this.dataEntradasSelected = [];
    this.showEntradas = false;
    this.dataForm = [];
    this.editedGps = [];
    this.gpsModelSelected = {};
    this.onlyView = false;

    this.formfields = {
      entrada_digital: [],
    };
    this.dataResult = [];
  }
}
